import { render } from "./ServiceAssignment.vue?vue&type=template&id=eea730bc&scoped=true"
import script from "./ServiceAssignment.vue?vue&type=script&lang=js"
export * from "./ServiceAssignment.vue?vue&type=script&lang=js"

import "./ServiceAssignment.vue?vue&type=style&index=0&id=eea730bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eea730bc"]])

export default __exports__